import { useDispatch, useSelector } from "react-redux";
import * as AuthActions from "../../../store/auth/actions";
import { Modal } from "react-bootstrap";
import logoutSVG from "./logout.svg";
import "./style.scss";
import { useState } from "react";
import { textIdentifier } from "../../../textIdentifier";

export default function SignoutModal({ handleClose = () => {} }) {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(true);
  const {lang} = useSelector(state => state.main)

  const handleSubmit = () => {
    try {
      dispatch(AuthActions.logoutUser());
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <Modal className="signout-modal" show>
      <Modal.Body>
        <img src={logoutSVG} alt="logout icon" />
        <h5>{textIdentifier["are-you-sure-want-to-logout"][lang]}?</h5>

        <div className="btn-container">
          <button onClick={handleClose} className="btn-outlined w-50">
            {textIdentifier["cancel"][lang]}
          </button>
          <button onClick={handleSubmit} className="btn-contained w-50">
            {textIdentifier["confirm"][lang]}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
